import { ColorRank, RadarSearchMode } from "../types/battle"
import { RANK_NAMES } from "./guardians"

export const FREE_BATTLE_LABEL = "Свободный бой"

export const FREE_BATTLE_DESCRIPTION =
  "Можно выбрать любую карту из колоды — ограничения по рангу нет."

export function isFreeBattleMode(searchMode?: RadarSearchMode): boolean {
  return searchMode !== "RANK"
}

export function formatChallengeModeLabel(
  searchMode?: RadarSearchMode,
  colorRank?: ColorRank
): string {
  if (searchMode === "RANK" && colorRank) {
    return `По рангу · ${RANK_NAMES[colorRank]}`
  }
  return FREE_BATTLE_LABEL
}

export function formatOutgoingChallengeModeLabel(
  searchMode?: RadarSearchMode,
  colorRank?: ColorRank
): string {
  if (searchMode === "RANK" && colorRank) {
    return `Дуэль ранга: ${RANK_NAMES[colorRank]}`
  }
  return FREE_BATTLE_LABEL
}
